import { render } from "./InquiryForm.vue?vue&type=template&id=42819d45&scoped=true"
import script from "./InquiryForm.vue?vue&type=script&lang=ts"
export * from "./InquiryForm.vue?vue&type=script&lang=ts"

import "./InquiryForm.vue?vue&type=style&index=0&id=42819d45&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42819d45"

export default script